import { QueueType, SearchQueuesSort } from 'types';

export interface QueueSortOption {
  id: string;
  label: string;
}

const queueSortOptions: QueueSortOption[] = [
  { id: SearchQueuesSort.Oldest, label: 'First Submitted - Oldest' },
  { id: SearchQueuesSort.Newest, label: 'First Submitted - Newest' },
  { id: SearchQueuesSort.OldestSubmitted, label: 'Last Submitted - Oldest' },
  { id: SearchQueuesSort.NewestSubmitted, label: 'Last Submitted - Newest' },
];

// QC priority (enable-qc-priority): sort by the package's target review time so techs can work the
// most urgent jobs first. Not shown unless the flag is on.
const targetReviewTimeSortOptions: QueueSortOption[] = [
  { id: SearchQueuesSort.TargetReviewTimeAsc, label: 'Target Review Time - Old-New' },
  { id: SearchQueuesSort.TargetReviewTimeDesc, label: 'Target Review Time - New-Old' },
];

const daysOnHoldSortOptions: QueueSortOption[] = [
  { id: SearchQueuesSort.OldestOnHold, label: 'Days on Hold - Oldest' },
  { id: SearchQueuesSort.NewestOnHold, label: 'Days on Hold - Newest' },
];

// Hold spans package types that never carry a review SLA; the search pushes those rows to the bottom
// rather than dropping them, so the sort stays meaningful there too.
const targetReviewTimeQueueTypes = new Set<QueueType>([
  QueueType.installPackage,
  QueueType.activationPackage,
  QueueType.holdMotion,
]);

export const getQueueSortOptions = ({
  queueType,
  enableQcPriority,
}: {
  queueType?: QueueType;
  enableQcPriority: boolean;
}): QueueSortOption[] => {
  let options = queueSortOptions;
  if (enableQcPriority && queueType && targetReviewTimeQueueTypes.has(queueType)) {
    options = [...options, ...targetReviewTimeSortOptions];
  }
  if (queueType === QueueType.holdMotion) {
    options = [...options, ...daysOnHoldSortOptions];
  }
  return options;
};
